import { DistribuicoesScreen } from "@/screens/financeiro/configuracoes/distribuicoes";

export function FinanceiroDistribuicoesPage() {
  return <DistribuicoesScreen />;
}
